var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandGoogleAdsStyleBlack = function SvgBrandGoogleAdsStyleBlack(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M.552 16.82 8.52 3.177c1.012.596 6.116 3.42 6.94 3.958L7.492 20.778c-.871 1.15-8.044-2.21-6.94-3.959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m23.445 16.819-7.968-13.64C14.363 1.325 11.964.65 9.994 1.746S7.424 5.2 8.537 7.136l7.968 13.642c1.114 1.853 3.513 2.527 5.484 1.432 1.884-1.095 2.57-3.537 1.456-5.39zM4 22.737c2.209 0 4-1.746 4-3.9s-1.791-3.9-4-3.9-4 1.746-4 3.9 1.79 3.9 4 3.9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandGoogleAdsStyleBlack);
export { ForwardRef as ReactComponent };